// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__yfQ_d","pageButton":"Pagination_pageButton__AHU_x","pageNumber":"Pagination_pageNumber__IVIXp","active":"Pagination_active__5Ws95"};